import * as React from 'react';
import { Box, Grid, Typography } from '@mui/material';

import { IZoneWithActions } from 'models';

import { ZoneCard } from './zone-card';

interface ZoneCardListProps {
  zones: Array<IZoneWithActions>;
  noDataLabel?: string;
  noDataSectionHeight?: number;
}

export const ZoneCardList: React.FC<ZoneCardListProps> = (props) => {
  const { zones, noDataLabel = 'No data', noDataSectionHeight = 240 } = props;

  if (zones.length === 0) {
    return (
      <Box display="flex" width="100%" height={noDataSectionHeight} alignItems="center" justifyContent="center">
        <Typography color="textSecondary" noWrap>
          {noDataLabel}
        </Typography>
      </Box>
    );
  }

  return (
    <Grid container spacing={2}>
      {zones.map((zone) => (
        <Grid key={`zone-card-${zone.id}`} item xs={12}>
          <ZoneCard zone={zone} />
        </Grid>
      ))}
    </Grid>
  );
};
